import { LuArrowRight } from "react-icons/lu";
import { Link } from "react-router-dom";
import { ProjectsGrid } from "./ProjectsGrid";
import { Project } from "../../models/project";

export const ProjectsTable = ({ projects }: { projects: Project[] }) => {
  return (
    <section className="card mt-5 sm:mt-7 p-4 sm:p-6 md:p-8">
      <div className="mb-6 flex items-center justify-between gap-4">
        <h2 className="text-2xl font-bold text-white">Останні проєкти</h2>
        <Link to="/dashboard" className="link-brand whitespace-nowrap">
          Всі проєкти <LuArrowRight aria-hidden />
        </Link>
      </div>

      <ProjectsGrid projects={projects} />
    </section>
  );
};
